
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    src: String
  }
})
export default class Avatar extends Vue {
  src!: string;
}
